import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sso-icon',
  standalone: true,
  imports: [CommonModule],
  template: `
    @switch (provider()) {
      @case ('google') {
        <svg width="20" height="20" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
          <path d="M9.003 18c2.43 0 4.467-.806 5.956-2.18L12.05 13.56c-.806.54-1.836.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9.003 18z" fill="#34A853"/>
          <path d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71s.102-1.17.282-1.71V4.958H.957C.347 6.173 0 7.548 0 9s.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
          <path d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.426 0 9.003 0 5.482 0 2.438 2.017.957 4.958L3.964 7.29c.708-2.127 2.692-3.71 5.036-3.71z" fill="#EA4335"/>
        </svg>
      }
      @case ('apple') {
        <svg width="20" height="20" viewBox="0 0 18 22" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.94 11.86c-.03-2.58 2.1-3.83 2.2-3.9-1.2-1.75-3.07-1.99-3.73-2.02-1.59-.16-3.1.94-3.9.94-.8 0-2.04-.91-3.35-.89-1.72.03-3.31 1-4.2 2.54-1.79 3.1-.46 7.7 1.29 10.22.85 1.23 1.87 2.62 3.21 2.57 1.31-.05 1.8-.84 3.38-.84 1.58 0 2.03.84 3.35.81 1.38-.02 2.28-1.27 3.14-2.5.99-1.43 1.4-2.81 1.42-2.88-.03-.01-2.72-1.05-2.75-4.15zM12.25 3.72c.71-.86 1.19-2.05 1.06-3.24-1.02.04-2.26.68-2.99 1.54-.66.76-1.23 1.97-1.08 3.13 1.14.09 2.3-.58 3.01-1.43z" fill="currentColor"/>
        </svg>
      }
    }
  `,
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    svg {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }
  `]
})
export class SsoIconComponent {
  provider = input.required<'google' | 'apple'>();
}
